export default __webpack_public_path__ + "static/media/feature6.92cd2cc6.svg";